export const messages = {
  en: {
    mappingDomain: {
      search: {
        title: 'Search Condition',
        domain: 'domain',
        domainName: 'domainName',
        seq: 'seq',
        remark: 'remark',
        createTime: 'createTime',
        placeholder: 'Please enter mappingDomain name'
      },
      list: {
        title: 'mappingDomain List'
      },
      dialog: {
        addTitle: 'Add MappingDomain',
        editTitle: 'Edit MappingDomain',
        delTitle: 'Delete MappingDomain',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        id: 'id',
        domain: 'domain',
        domainName: 'domainName',
        seq: 'seq',
        remark: 'remark',
        createTime: 'createTime',
      },
      table: {
        id: 'id',
        domain: 'domain',
        domainName: 'domainName',
        seq: 'seq',
        remark: 'remark',
        createTime: 'createTime',
      },
      validate: {
        id: 'Please enter id',
        domain: 'Please enter domain',
        domainName: 'Please enter domainName',
        seq: 'Please enter seq',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add MappingDomain success'
      },
      edit: {
        success: 'Edit MappingDomain success'
      },
      delete: {
        success: 'Delete MappingDomain success',
        confirm: 'Are you sure to delete this mappingDomain?'
      },
      fetchError: 'Failed to fetch mappingDomain list'
    }
  },
  zh: {
    mappingDomain: {
      search: {
        title: '查询条件',
        domain: '域',
        domainName: '配置项',
        seq: '排序',
        remark: '描述',
        createTime: '创建时间',
        placeholder: '请输入配置项名称'
      },
      list: {
        title: '配置项'
      },
      dialog: {
        addTitle: '添加配置项',
        editTitle: '编辑配置项',
        delTitle: '删除配置项',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        id: 'id',
        domain: '域',
        domainName: '配置项',
        seq: '排序',
        remark: '描述',
        createTime: '创建时间',
      },
      table: {
        id: 'id',
        domain: '域',
        domainName: '配置项',
        seq: '排序',
        remark: '描述',
        createTime: '创建时间',
      },
      validate: {
        id: '请输入id',
        domain: '请输入域',
        domainName: '请输入配置项',
        seq: '请输入排序',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加配置项成功'
      },
      edit: {
        success: '编辑配置项成功'
      },
      delete: {
        success: '删除配置项成功',
        confirm: '确认删除该配置项吗？'
      },
      fetchError: '获取配置项列表失败'
    }
  }
}